import React from 'react';
import styles from './TopicView.module.scss';
import { useOutletContext, useParams } from 'react-router-dom';
import { AppConfig, Topic } from '../../Models';
import { SupportContent } from '../../Components/SupportContent/SupportContent';
import { FaqList } from '../../Components/FaqList/FaqList';
import { getFaqsByIds, getTopic } from '../../Helpers';
import { TopicDeprecated } from './TopicDeprecated/TopicDeprecated';

function TopicView(): React.ReactElement<{}> {
  const config = useOutletContext<AppConfig>();
  const { id } = useParams();

  const topic: Topic | undefined = id ? getTopic(config, +id) : undefined;

  if (!topic) {
    throw Error(`No topic found with the provided id (${id})`);
  }

  const faqs = getFaqsByIds(config, topic.related_questions);

  return (
    <SupportContent section="Topic" title={topic.name}>
      {!topic.active && <TopicDeprecated topic={topic} />}

      {topic.active && (
        <div className={styles.topicView}>
          <h2 className={styles.title}>{topic.name}</h2>

          <FaqList faqs={faqs} />
        </div>
      )}
    </SupportContent>
  );
}

export default TopicView;
